import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-keep-search',
    templateUrl: './keep-search.component.html',
    styleUrl: './keep-search.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeepSearchComponent {

}
